import { createClient } from '@supabase/supabase-js';

// Access environment variables securely
// Note: In a real deployment, these should be in a .env file
const supabaseUrl = (import.meta as any).env.VITE_SUPABASE_URL || 'https://sxwqmfyrwrnujhytfqzi.supabase.co';
const supabaseAnonKey = (import.meta as any).env.VITE_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InN4d3FtZnlyd3JudWpoeXRmcXppIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzAxNDgwNDUsImV4cCI6MjA4NTcyNDA0NX0.n__rYmZwsE273i1p3nWW213QBY45PWuTtJyQJxbiwkA';

// Create a single supabase client for interacting with your database
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
    db: {
        schema: 'forms' // Direciona todas as consultas para o schema forms
    },
    auth: {
        storageKey: 'asa-branca-forms-auth', // Evita conflitos de sessao com outras aplicacoes
        // Disable auto-detection of session in URL to prevent conflicts
        // This is often a cause of issues in SPA routers
        detectSessionInUrl: false,

        // Ensure persistence is on (default), but do not mess with 'lock' options
        // incorrectly as that causes runtime crashes in newer supabase-js versions.
        persistSession: true,
        autoRefreshToken: true,
    }
});
